export const PAGE_INFO = `
pageInfo {
	offsetPagination {
		total
		hasMore
		hasPrevious
	}
}
`